/*
 * Content protection (deterrent only)
 * ------------------------------------------------------------
 * Discourages casual copying on the live storefront by blocking:
 *   - right-click (except in inputs, textareas, selects and contenteditable fields)
 *   - F12, Ctrl+Shift+I/J/C, Cmd+Option+I/J/C (DevTools)
 *   - Ctrl+U / Cmd+Option+U (view source)
 *   - Ctrl+S / Cmd+S (save page)
 *   - dragging images
 * It does not run in the Shopify theme editor, and it leaves copy/paste,
 * text selection, keyboard navigation and screen readers untouched.
 * It cannot stop a determined user (browser menus, disabling JS, etc.).
 *
 * To turn it off: remove the content-protection.js <script> tag near the end
 * of layout/theme.liquid (or delete this file's contents).
 */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  function isEditable(el) {
    return !!(
      el &&
      el.closest &&
      el.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]')
    );
  }

  document.addEventListener('contextmenu', function (e) {
    if (!isEditable(e.target)) e.preventDefault();
  });

  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  });

  document.addEventListener('keydown', function (e) {
    var key = (e.key || '').toLowerCase();
    var code = e.code || '';
    var blocked =
      key === 'f12' ||
      // Windows/Linux: Ctrl+Shift+I/J/C
      (e.ctrlKey && e.shiftKey && (code === 'KeyI' || code === 'KeyJ' || code === 'KeyC')) ||
      // Mac: Cmd+Option+I/J/C/U
      (e.metaKey && e.altKey && (code === 'KeyI' || code === 'KeyJ' || code === 'KeyC' || code === 'KeyU')) ||
      // View source: Ctrl+U
      (e.ctrlKey && !e.shiftKey && !e.altKey && code === 'KeyU') ||
      // Save page: Ctrl+S / Cmd+S
      ((e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && code === 'KeyS');

    if (blocked) e.preventDefault();
  });
})();
